/* Inline auto-playing muted video with an unmute toggle.
   Used in vendor grids / feeds (FavoriteHeart overlays the corner). */
import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { FavoriteHeart } from "@/lib/favorites";

export const MuteToggleVideo = ({ src, poster, className = "", vendor_slug }) => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    if (!ref.current) return undefined;
    const el = ref.current;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) el.play().catch(() => {});
          else el.pause();
        });
      },
      { threshold: 0.25 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div className="relative w-full h-full">
      <video
        ref={ref}
        src={src}
        poster={poster}
        muted={muted}
        loop
        playsInline
        preload="metadata"
        autoPlay
        className={className || "block w-full h-full object-cover"}
      />
      <button
        type="button"
        data-testid="video-mute-toggle"
        onClick={(e) => {
          e.stopPropagation();
          setMuted((m) => !m);
        }}
        aria-label={muted ? "Unmute video" : "Mute video"}
        className="absolute bottom-2 right-2 inline-flex h-8 w-8 items-center justify-center bg-black/60 text-white/90 backdrop-blur-sm hover:bg-black/80 transition-colors"
      >
        {muted ? (
          <VolumeX size={13} strokeWidth={1.8} />
        ) : (
          <Volume2 size={13} strokeWidth={1.8} />
        )}
      </button>
      {vendor_slug && (
        <FavoriteHeart
          vendor_slug={vendor_slug}
          size={13}
          className="absolute top-2 left-2 h-8 w-8"
        />
      )}
    </div>
  );
};
